import React from 'react';
import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';

const TONE_BY_STATUS = {
  Active: 'success',
  Draft: 'warning',
  Inactive: 'error',
  Pending: 'info',
};

export default function StatusPill({ status, sx }) {
  const tone = TONE_BY_STATUS[status] || 'default';
  return (
    <Chip
      size="small"
      label={status || '—'}
      sx={{
        height: 22,
        fontSize: 10.5,
        fontWeight: 600,
        bgcolor: (t) => {
          if (tone === 'default') return alpha(t.palette.grey[500], 0.16);
          return alpha(t.palette[tone].main, 0.16);
        },
        color: (t) => {
          if (tone === 'default') return t.palette.text.secondary;
          return t.palette[tone].dark || t.palette[tone].main;
        },
        border: (t) => {
          if (tone === 'default') return `1px solid ${alpha(t.palette.grey[500], 0.32)}`;
          return `1px solid ${alpha(t.palette[tone].main, 0.4)}`;
        },
        ...sx,
      }}
    />
  );
}
